const lastCandidateIndex = (messages) => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    if (messages[index].role === 'candidate') return index;
  }
  return -1;
};

const appendAttempt = (messages, text, ts, deliveryStatus) => {
  const next = [...messages];
  const index = lastCandidateIndex(next);
  if (index >= 0 && next[index].deliveryStatus === 'not_sent') next.splice(index, 1);
  next.push({ role: 'candidate', text, ts, deliveryStatus });
  return next;
};

export const appendVoiceAttempt = (messages, text, ts) => appendAttempt(messages, text || '…', ts, 'sending');
export const appendTypedAttempt = (messages, text, ts) => appendAttempt(messages, text, ts, 'submitting');

export const updateLastCandidate = (messages, patch) => {
  const index = lastCandidateIndex(messages);
  if (index < 0) return messages;
  const next = [...messages];
  next[index] = { ...next[index], ...patch };
  return next;
};
